<template>
  <section class="contentWrap">
    <transition-group name="slide-fade">
      <debitos :key="step" v-if="step == 'debitos'" :session="session" :step="current" :debitos="debitos" @onNext="next($event, 'debitos')"/>
      <pagamento
        v-if="step == 'pagamento'"
        :key="step"
        :step="current"
        :v-model:wStep="innerStep"
        :session="session"
        :debitos="debitos"
        @onNext="next($event, 'pagamento')"
      />
      <parcelas :key="step" v-if="step == 'parcelas'" :session="session" :step="current" :debitos="debitos" @onNext="next($event, 'parcelas')"/>
      <termo :key="step" v-if="step == 'termo'" :session="session" :step="current" :debitos="debitos" :idProposta="idProposta || idPropostaLocal" @onNext="next($event, 'termo')"/>
      <checkout :key="step" v-if="step == 'checkout'" :session="session" :step="current" :debitos="debitos" :termo="termo" :idProposta="idProposta || idPropostaLocal" @onNext="next($event, 'checkout')"/>
      <final :key="step" v-if="step == 'final'" :session="session" :step="current" />
    </transition-group>
  </section>
</template>

<script>
import Debitos from '@/components/financeiro/negocieja/app/template/Debitos.vue'
import Pagamento from '@/components/financeiro/negocieja/app/template/Pagamento.vue'
import Checkout from '@/components/financeiro/negocieja/app/template/Checkout.vue'
import Termo from '@/components/financeiro/negocieja/app/template/Termo.vue'
import Final from '@/components/financeiro/negocieja/app/template/Final.vue'
import Parcelas from '@/components/financeiro/negocieja/app/template/Parcelas.vue'
import NegociaService from '@/services/negocieja.service'

export default {
  components: {
    Debitos, Pagamento, Checkout, Termo, Final, Parcelas
  },
  props: {
    session: String,
    step: String,
    steps: Array,
    debitos: Object,
    idProposta: [String, Number]
  },
  watch: {
    step ( value ) {
      console.log("watch step:", value)
      if ( value == 'pagamento' ) this.innerStep = 1
    }
  },
  data () {
    return {
      current: 'debitos',
      termo: null,
      innerStep: 1,
      idPropostaLocal: null,  
      carregandoTermo: false
    }
  },
  mounted () {
    console.log("session:", this.session)
    console.log("steps:", this.steps)
    console.log("step:", this.step)
  },  
  methods: {
    cpfFromLocalStorage () {
      try {
        const raw = localStorage.getItem('negociacaoDados')
        const obj = raw ? JSON.parse(raw) : {}

        const cpf =
          obj.cpf_responsavel_financeiro ||
          obj.cpf ||
          obj?.responsavelFinanceiro?.cpf ||
          ''

        const digits = String(cpf).replace(/\D/g, '').slice(-11)
        return digits.length === 11 ? digits : ''
      } catch (e) {
        return ''
      }
    },
    resolveMencodigos () {
      if (Array.isArray(this.debitos?.mencodigos) && this.debitos.mencodigos.length) {
        return this.debitos.mencodigos
      }
      const itens = this.debitos?.itens || this.debitos?.debitos || []
      return itens.map(i => i.mencodigo || i.menCodigo || i.codigo).filter(Boolean)
    },
    resolveValoresCorrigidos () {
      try {
        const raw = localStorage.getItem('negociacaoDados')
        const obj = raw ? JSON.parse(raw) : null
        if (Array.isArray(obj?.valores_corrigidos) && obj.valores_corrigidos.length) {
          return obj.valores_corrigidos
        }
      } catch (e) {console.log(e)}

      if (Array.isArray(this.debitos?.valores_corrigidos) && this.debitos.valores_corrigidos.length) {
        return this.debitos.valores_corrigidos
      }

      const itens = this.debitos?.itens || this.debitos?.debitos || []
      const pickValor = (i) =>
        i.valor_corrigido ??
        i.valorCorrigido ??
        i.valor_atualizado ??
        i.valorAtual ??
        i.valorFinalCobrado ??
        i.valor
      return itens
        .map(i => ({
          mencodigo: i.mencodigo || i.menCodigo || i.codigo,
          valor_corrigido: String(pickValor(i) ?? 0)
        }))
        .filter(v => v.mencodigo)
    },
    buildPayload (data) {
      const totalOriginal =
        data?.valorOriginal ?? data?.totalOriginal ?? this.debitos?.valorOriginal ?? 0
      const totalFinal =
        data?.total ?? data?.totalFinal ?? this.debitos?.valorFinal ?? this.debitos?.valorFinalCobrado ?? 0

      const forma = data?.forma || data?.formaPagamento || {}
      const entradaPercent = data?.entradaPercent ?? null
      const qtdParcelas = data?.parcelas ?? forma?.qtdParcelas ?? null
      const qtdParcelasEntrada = data?.qtdParcelasEntrada ?? null
      const entradaTipo = data?.entradaTipo ?? null
      const parcelaTipo = data?.parcelaTipo ?? null

      const lista = Array.isArray(data?.parcelasCalculadas) ? data.parcelasCalculadas : []
      const entradaParcelas = lista.filter(p => p.tipoArrecadacao === 'entrada')
      const parcelaParcelas = lista.filter(p => p.tipoArrecadacao === 'parcela')

      return {
        cpf_responsavel_financeiro: this.cpfFromLocalStorage(),
        mencodigos: this.resolveMencodigos(),
        valores_corrigidos: this.resolveValoresCorrigidos(),
        valor: {
          totalOriginal,
          totalFinal
        },
        idNegocieJaCampanha: forma?.idNegocieJaCampanha ?? null,
        idNegocieJaPolitica: forma?.idNegocieJaPolitica ?? null,
        formaPagamento: {
          idFormaPagamento: forma?.idNegocieJaFormaPagamento ?? forma?.idFormaPagamento ?? null,
          percentualEntrada: entradaPercent,
          qtdParcelas: qtdParcelas,
          qtdParcelasEntrada: qtdParcelasEntrada
        },
        entrada: {
          pix: entradaTipo === 'pix' ? 1 : null,
          boleto: entradaTipo === 'boleto' ? 1 : null,
          cartao: entradaTipo === 'cartao' ? 1 : null,
          parcelas: entradaParcelas
        },
        parcelas: {
          pix: parcelaTipo === 'pix' ? 1 : null,
          boleto: parcelaTipo === 'boleto' ? 1 : null,
          cartao: parcelaTipo === 'cartao' ? 1 : null,
          parcelas: parcelaParcelas
        }
      }
    },
    async next (data, current) {
      const currentIndex = this.steps.findIndex(step => step.slug === current)
      const nextIndex = currentIndex + 1
      const nextSlug = this.steps[nextIndex]?.slug

      if (nextSlug === 'termo') {
        try {
          this.carregandoTermo = true
          const payload = this.buildPayload(data)
          const res = await NegociaService.gerarProposta(payload)

          if (res?.data?.pdf) {
            this.termo = `data:application/pdf;base64,${res.data.pdf}`
          }

          const uuid = res?.data?.uuid || null
          this.idPropostaLocal = uuid

          this.$router.push({
            name: 'negociejaApp',
            params: { session: 'negociar', step: 'termo', idProposta: uuid }
          })
        // } catch (e) {
        //   console.error(e)
        //   window?.toaster?.emit?.('open', {
        //     style: 'error',
        //     message: 'Erro ao gerar o termo de acordo.',
        //     floater: true
        //   })
        } finally {
          this.carregandoTermo = false
        }
        return
      }

      if (current === 'termo') {
        this.termo = data
      }

      const currentApp = this.$route.name
      // console.log("currentApp:", currentApp)
      this.$router.push({
        name: currentApp,
        params: { session: 'negociar', step: nextSlug }
      })
    },
    prev (data, current) {
      const currentIndex = this.steps.findIndex(step => step.slug === current)
      const prevIndex = currentIndex - 1
      const prev = this.steps[prevIndex].slug

      this.$router.push({ name: 'negociejaApp', params: { session: 'negociar', step: prev } })
    }
  }
}
</script>


<style lang="scss" scoped>
  .contentWrap {
    flex: 1;
    max-height: 100%;
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all 0.3s ease;
    position: absolute;
    width: 100%;
  }

  .slide-fade-enter-from {
    transform: translateX(100%);
    opacity: 0;
  }
  
  .slide-fade-enter-to {
    transform: translateX(0);
    opacity: 1;
  }

  .slide-fade-leave-from {
    transform: translateX(0);
    opacity: 1;
  }
  .slide-fade-leave-to {
    transform: translateX(-100%);
    opacity: 0;
  }

  .contentWrap {
    position: relative;
    overflow: hidden;
    min-height: 200px; // or your content's height
  }
</style>

